import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { serviceApi } from "../../API/Api";

import ServiceCardItem from "./ServiceCardItem";

const TrendingServices = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(serviceApi)
      .then((res) => res.json())
      .then((result) => {
        setData(result.slice(0, 4));
      });
  }, []);

  return (
    <Box mt={8} sx={{ background: "transparent" }}>
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          px: 2,
          textAlign: "center",
          gap: 1.5,
          mb: 4,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "26pt", md: "34pt" },
            background: "linear-gradient(to right, #00C9A7, #0074E4)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "0.5px",
          }}
        >
          Popular Services
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            fontSize: { xs: "13pt", md: "15pt" },
            color: "#9E9E9E",
            maxWidth: "600px",
          }}
        >
          Discover the most viewed and all-time top-selling services from our
          expert community.
        </Typography>
      </Stack>

      <Container sx={{ mt: 3 }}>
        {/* <Grid container spacing={3}>
          {data?.map((element) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={element.service_refer}>
              <ServiceCardItem data={element} />
            </Grid>
          ))}
        </Grid> */}

        <Grid container spacing={2}>
          {data.map((item, index) => (
            <Grid item xs={6} sm={6} md={3} key={index}>
              <ServiceCardItem data={item} />
            </Grid>
          ))}
        </Grid>

        <Stack direction="row" justifyContent="center" mt={5}>
          <Button
            variant="contained"
            onClick={() => navigate("/servicelist")}
            sx={{
              px: 5,
              py: 1.5,
              fontSize: "16pt",
              fontWeight: 600,
              textTransform: "none",
              background:
                "linear-gradient(135deg, rgba(0,201,167,0.9), rgba(0,116,228,0.9))",
              borderRadius: "50px",
              boxShadow: "0px 8px 24px rgba(0,201,167,0.3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
                background:
                  "linear-gradient(135deg, rgba(0,201,167,1), rgba(0,116,228,1))",
              },
            }}
          >
            Load more...
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default TrendingServices;
